<template>
  <l-layout layout="xs12">
    <v-card>
      <v-card-title class="py-0 my-0" style="height: 80px">
        <span class="title pl-2">{{vehicle.plate}}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md fluid class="pt-0">
          <person-info-card flat expand :person="vehicle.owner" type="personReservation"></person-info-card>
          <l-data-table
            ref="reservationList"
            class="my-5"
            flat
            :headers="reservationHeaders"
            :get-data-func="getReservations"
            :init-pagination="{sortBy: 'creationTime', descending: true}"
            auto-actions
            clickable
            :filter-items="filter"
            no-data-text="没有预约历史"
            hide-title-search
            @click:row="goReservation"
          >
            <template slot="title">
              <v-subheader class="px-0 pr-4">预约历史</v-subheader>
            </template>
          </l-data-table>
          <v-divider></v-divider>
<!--          <l-data-table-->
<!--            class="my-5"-->
<!--            flat-->
<!--            :headers="passHeaders"-->
<!--            :auto-title="0"-->
<!--            :auto-headers="0"-->
<!--            :get-data-func="getPassLogs"-->
<!--            auto-actions-->
<!--            hide-search-->
<!--            :init-pagination="{sortBy: 'passDatetime', descending: true}"-->
<!--            hide-title-search-->
<!--            no-data-text="没有通行记录"-->
<!--          >-->
<!--            <template slot="title">-->
<!--              <v-subheader class="px-0">通行记录</v-subheader>-->
<!--            </template>-->
<!--          </l-data-table>-->
<!--          <v-divider></v-divider>-->
        </v-container>
      </v-card-text>
    </v-card>
  </l-layout>
</template>

<script>
import PersonInfoCard from '../../../components/personInfoCard'
import {time} from '../../../ladmin/utils'
import {Reservation, VIOLATION_STATUS_TEXT} from '../../../object'
let typeName = {
  person: '个人预约',
  admin: '高级预约',
  org: '单位预约',
  letter_business: '商业函件预约',
  letter_work: '工作函件预约',
  letter_append: '函件预约追加',
  letter_append_self: '函件预约自助登记'
}
export default {
  name: 'vehicleDetailsContent',
  components: {PersonInfoCard},
  props: {
    vehicle: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    showReservationHistory: false,
    passHeaders: [
      {text: '通行时间', value: 'passDatetime', align: 'left', placeholder: 'N/A'},
      {text: '通行园区', value: 'parkingLotName', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '通行关口', value: 'controllerName', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '是否放行', value: 'status', align: 'right', placeholder: 'N/A', f: v => v + '' === '1' ? '抬杆放行' : '禁止通行'},
      {text: '通行详情', value: 'details', align: 'right', placeholder: 'N/A', tooltip: true, maxWidth: '14em'}
    ],
    reservationHeaders: [
      {text: '来访人', value: 'visitorName', align: 'left', placeholder: 'N/A', sortable: false},
      {text: '联系人', value: 'ownerName', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '申请人', value: 'applicantName', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '预约类型', value: 'type', align: 'right', placeholder: 'N/A', sortable: false, f: (v) => (typeName[v])},
      {text: '开始时间', value: 'startDatetime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '结束时间', value: 'endDatetime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '是否有效', value: 'status', align: 'left', placeholder: 'N/A', f: (v) => (v === '1' ? '有效' : '失效')},
    ],
    filter: [
      {
        prependIcon: '$vuetify.icons.edit',
        key: 'status',
        value: '{"r_h_status":"1"}',
        label: '是否有效',
        type: 'select',
        layout: ['xs12', 'sm4'],
        items: [
          {
            value: '',
            text: '全部'
          },
          {
            value: '{"r_h_status":"1"}',
            text: '有效'
          },
          {
            value: '{"r_h_status":"-1"}',
            text: '失效'
          }],
      },
      {
        label: '开始时间',
        layout: 'xs12, sm4',
        type: 'duration',
        key: 'startDatetime',
        value: {},
        range: true,
        f: v => {
          if (!v.startDatetime && !v.endDatetime) {
            return null
          }
          else {
            let s = time.toTimeStamp(v.startDatetime) || 0
            let e = time.toTimeStamp(v.endDatetime) || 9999999999999
            return [s, e]
          }
        }
      },
      {
        label: '截止时间',
        layout: 'xs12, sm4',
        type: 'duration',
        key: 'endDatetime',
        value: {},
        range: true,
        f: v => {
          if (!v.startDatetime && !v.endDatetime) {
            return null
          }
          else {
            let s = time.toTimeStamp(v.startDatetime) || 0
            let e = time.toTimeStamp(v.endDatetime) || 9999999999999
            return [s, e]
          }
        }
      }],
    vehicleType: {
      per_ve: '校内用户车辆',
      coo_ve: '合作用户车辆',
      reservation: '预约车辆',
      org_ve: '校内单位公车'
    }
  }),
  created () {
    console.log(this.vehicle)
  },
  methods: {
    toggleReservationHistory () {
      this.$refs.reservationList.refresh(true)
    },
    async getReservations ({pagination, sortStack, filterItems}) {
      let {items,amount} = await this.$store.dispatch('personReservation/getReservations', {
        pagination: {page: 1, rowsPerPage: 3},
        sortStack,
        filter: filterItems,
        locate: this.showReservationHistory ? 'history' : 'runtime',
        search: {
          key: 'plate', value: this.vehicle.plate,
        }
      })
      return {items,amount}
    },
    getPassLogs ({pagination, sortStack, filter}) {
      return this.$store.dispatch('personPassControl/getLogs', {
        pagination,
        sortStack,
        filter,
        search: {key: 'plate', value: this.vehicle.plate}
      })
    },
    async goReservation ({item}) {
      console.log(item)
      const map = {
        [Reservation.PERSONAL]: 'PersonPersonalReservationDetails',
        [Reservation.ORG]: 'PersonReservationOrgDetails',
        [Reservation.ADMIN]: 'PersonAdminReservationDetails',
      }
      let routeName = map[item.type]
      if (routeName) {
        this.$router.push({
          name: routeName,
          params: {
            plate: item.plate
          },
          query: {id: item.groupId}
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
